<template>
    <button class="card" :class="{ 'is-disabled': disabled }" :disabled="disabled" @click="click">
        <div class="card-body">
            <div class="icons">
                <template v-if="viaKevi">
                    <div class="icon">
                        <img src="/images/icons/kevi-horse.svg" :alt="t('header-logo_alt')">
                    </div>
                    <span>
                        <Icon icon-class="ui-chevron-right-double" size="4" color="#000" />
                    </span>
                </template>
                <div class="icon">
                    <slot name="icon"></slot>
                </div>
            </div>
            <div class="badge">
                <slot name="badge"></slot>
            </div>
            <div v-if="!disabled && (monthlyPrice || creditPrice)" class="pricing">
                <KvTooltip v-if="monthlyPrice" :text="t('settings-connections-table-monthly_value')" placement="top">
                    <span class="price">R${{ monthlyPrice }}</span>
                </KvTooltip>
                <span v-if="monthlyPrice && creditPrice" class="price-divider">/</span>
                <KvTooltip v-if="creditPrice" :text="t('settings-connections-sender_form-per_message_sent')" placement="top">
                    <span class="price">{{ creditPrice }}</span>
                </KvTooltip>
            </div>
            <h6>{{ title }}</h6>
            <p>{{ description }}</p>
        </div>
    </button>
</template>
<script>
import KvTooltip from "@/components/ui/kv-tooltip.vue";

export default {
    name: "card",
    components: {
        KvTooltip,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        viaKevi: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        monthlyPrice: {
            type: [String, Number],
            default: null,
        },
        creditPrice: {
            type: [String, Number],
            default: null,
        },
    },
    methods: {
        click() {
            if (this.disabled) return;
            this.$emit('click');
        },
    },
}
</script>
<style lang="scss" scoped>
.card {
    border-radius: 16px;
    border: 1px solid var(--Black-200, #E5E7EB);
    background: #FFF;
    cursor: pointer;
    &:hover {
        border-radius: 16px;
        border: 1px solid var(--Black-200, #E5E7EB);
        background: var(--Black-100, #F3F4F6);
    }

    &.is-disabled,
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &.is-disabled:hover,
    &:disabled:hover {
        background: #FFF;
    }

    .card-body {
        display: flex;
        flex-direction: column;
        gap: 16px; 
        text-align: left;
        h6 {
            margin-bottom: 0;
            text-align: left;
        }
        p {
            margin-bottom: 0;
            color: var(--Black-500, #6C737F);
            font-size: 12px;
            font-weight: 400;
            line-height: 130%;
        }
        .icons {
            display: flex;
            align-items: center;
            gap: 8px;
            span {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .icon {
                height: 24px;
                display: flex;
                align-items: center;
                gap: 8px;
                img:first-child {
                    width: auto;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }
            }
        }
        .badge {
            position: absolute;
            top: 16px;
            right: 16px;
            z-index: 1;
            img {
                height: 24px;
            }

            :deep(.coming-soon-badge) {
                display: inline-flex;
                align-items: center;
                height: 24px;
                padding: 0 10px;
                border-radius: 999px;
                background: var(--Black-100, #F3F4F6);
                border: 1px solid var(--Black-200, #E5E7EB);
                color: var(--Black-600, #4D5761);
                font-size: 12px;
                font-weight: 600;
                line-height: 1;
            }
        }
        .pricing {
            position: absolute;
            top: 16px;
            right: 16px;
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 11px;
            font-weight: 600;
            z-index: 1;
            
            .price {
                color: var(--utility-success-500, #17B26A);
                cursor: help;
                
                &:hover {
                    text-decoration: underline;
                    text-decoration-style: dotted;
                }
            }
            
            .price-divider {
                color: var(--Black-400, #9DA4AE);
            }
        }
    }
}
</style>